import React from 'react';
import { ClipboardListIcon } from 'lucide-react';
import { ActingDetailQueryResponse } from '@area-restrita/api-client/model/actingDetailQueryResponse';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import ActingChecklistStep from './ActingChecklistStep';
import { getCompletedStepsCount } from './actingDetailsPresentation';

interface IProps {
  acting: ActingDetailQueryResponse;
}

const ActingChecklist: React.FC<IProps> = ({ acting }) => {
  const completedSteps = getCompletedStepsCount(acting.steps);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Checklist da execução</CardTitle>
        <CardDescription>
          {acting.usedChecklist
            ? `${acting.usedChecklist.name} · ${completedSteps} de ${acting.totalChecklistSteps} concluídas`
            : 'Nenhum checklist foi utilizado nesta execução'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {!acting.usedChecklist || !acting.steps.length ? (
          <div className="flex min-h-36 flex-col items-center justify-center gap-2 rounded-lg border border-dashed p-6 text-center">
            <ClipboardListIcon className="size-6 text-muted-foreground" />
            <p className="font-medium">
              {acting.usedChecklist
                ? 'Nenhuma etapa registrada'
                : 'Execução sem checklist'}
            </p>
            <p className="text-sm text-muted-foreground">
              {acting.usedChecklist
                ? 'As etapas aparecerão aqui quando forem iniciadas pelo motorista.'
                : 'Não há respostas de checklist para consultar.'}
            </p>
          </div>
        ) : (
          <div className="grid gap-3 lg:grid-cols-2">
            {acting.steps.map((step) => (
              <ActingChecklistStep key={step.id} step={step} />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ActingChecklist;
